import { Component, ElementRef } from "@angular/core";
import { Broadcaster } from "../service/Broadcaster";
import { updateInfoItem } from "../class/broadcaster/update-info-item";
import { removeItemMenu } from "../class/broadcaster/left-menu/remove-item-menu";


@Component({
    selector: "confirm-comp",
    templateUrl: "html/confirm.component.html",
    styleUrls: ["css/confirm.component.css"]
})
export class ConfirmComponent {
    class: string = "";
    display: string = "none";
    dataRemove: any;
    action: string;
    message: string = "";
    constructor(private broadcaster: Broadcaster, private elRef: ElementRef) { }
    ngOnInit() {
        this.broadcaster.on<any>("Confirm").subscribe(data => {

            this.defaultData(data);
        });
        this.elRef.nativeElement.querySelector(".mask-confirm").addEventListener(
            "click",
            (event) => {
                this.Cancel();
            }, false);
    }
    Confirm() {
        this.Cancel();
        if (this.action === "remove" || this.action === "remove-product" || this.action === "remove-category") {
            this.broadcaster.broadcast("removeItemMenu", new removeItemMenu(this.dataRemove,this.action) );
        }
        if (this.action === "saveInfoExpenseAndShowMedia") {
            this.broadcaster.broadcast("saveInfoExpenseAndShowMediaNextStep", null);
        }
        if (this.action === "closedEditflightDate") {
            this.broadcaster.broadcast("closedEditflightDate", null);
        }
        if (this.action === "closedMediaCalendar") {
            this.broadcaster.broadcast("closedMediaCalendar", null);
        }
        if (this.action === "closedSales") {
            this.broadcaster.broadcast("closedSales", null);
        }
        if (this.action === "closedInfoExpense") {
            this.broadcaster.broadcast("updateInfoItem",new updateInfoItem({
                id: null,
            }));
        }


    }
    defaultData(data: any) {
        if (data.data === null) {
            this.Cancel();
            return;
        }
        this.elRef.nativeElement.querySelector(".mask-confirm").style.display = "block";
        this.dataRemove = data.data;
        this.action = data.action;
        if (this.action === "remove" || this.action === "remove-product" || this.action === "remove-category") {
            this.message = "Are you Sure?";
        }
        if (this.action === "closedEditflightDate" || this.action === "closedInfoExpense" || this.action === "closedMediaCalendar" || this.action === "closedSales") {
            this.message = "Are you sure? Everything not saved will be lost";
        }
        if (this.action === "saveInfoExpenseAndShowMedia") {
            this.message = "To edit the Media category will open. Are you sure?";
        }
        this.class = "m--fade";
        this.display = "block";
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "block";
        document.body.querySelector("main").classList.add("m--blur");

    }

    Cancel() {
        if (this.display === "block") {
            this.display = "none";
            this.class = "";
            this.elRef.nativeElement.querySelector(".mask-confirm").style.display = "none";
            if (this.action === "closedMediaCalendar" || this.action === "closedSales") return;
            (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "none";
            document.body.querySelector("main").classList.remove("m--blur");
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/confirm/confirm.component.ts